<template>
	<transition name="block">
		<div v-if="value" class="d-preloader animated">
			<img style="max-width: 250px; width: 100%" src="@/assets/imdex_x.svg" alt="" />
		</div>
	</transition>
</template>
<script>
export default {
	name: "imdex-preloader",
	props: {
		value: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		window.document.getElementById("app").appendChild(this.$el);
	},
	watch: {
		value(v) {
			if (v) {
				setTimeout(() => {
					this.$emit("input", false);
				}, 3000);
			}
		}
	}
};
</script>
<style scoped lang="scss">
.block-enter {
	opacity: 0;
}
.block-enter-active {
	transition: all 0.3s ease;
}
.block-leave {
}
.block-leave-active {
	transition: all 0.3s ease;
	opacity: 0;
}
.d-preloader {
	width: 100%;
	height: 100vh;
	display: flex;
	top: 0;
	left: 0;
	position: fixed;
	z-index: 1000;
	align-items: center;
	justify-content: center;
	background: $imdex-primary;
}
</style>
